module.exports = __webpack_public_path__ + "img/8.1e421523.png";